import React from 'react';
import { Snackbar, Alert } from '@mui/material';

interface BulkUpdateNotificationsProps {
  notification: { open: boolean; message: string; severity: 'success' | 'error' | 'info' | 'warning' };
  onCloseNotification: () => void;
  showSubmitToast: boolean;
  onCloseSubmitToast: () => void;
  success: boolean;
  submitError: string | null;
}

const BulkUpdateNotifications: React.FC<BulkUpdateNotificationsProps> = ({
  notification,
  onCloseNotification,
  showSubmitToast,
  onCloseSubmitToast,
  success,
  submitError,
}) => (
  <>
    <Snackbar
      open={notification.open}
      autoHideDuration={6000}
      onClose={onCloseNotification}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert onClose={onCloseNotification} severity={notification.severity} sx={{ width: '100%' }}>
        {notification.message}
      </Alert>
    </Snackbar>
    <Snackbar
      open={showSubmitToast}
      autoHideDuration={6000}
      onClose={onCloseSubmitToast}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <Alert onClose={onCloseSubmitToast} severity={success ? 'success' : 'error'} sx={{ width: '100%' }}>
        {success
          ? 'Changes submitted successfully!'
          : submitError
            ? `Error submitting changes: ${submitError}`
            : null}
      </Alert>
    </Snackbar>
  </>
);

export default BulkUpdateNotifications; 